export const defaultState = {
  id: null,
  user: null,
  userOption: null,
  course: null,
  courseOption: null,
  name: '',
  completionDate: null,
  completionPlace: '',
  controlNumber: '',
  cpdHours: '',
  competencies: [],
  competencyOptions: [],
  isProgramme: false,
  programmeSubset: '',
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
